/** @deprecated use `BreakpointName` type from `@noths/polaris-client-ribbons-base` instead of this enum */
export var Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint["L"] = "L";
  Breakpoint["M"] = "M";
  Breakpoint["S"] = "S";
  Breakpoint["XL"] = "XL";
  Breakpoint["XS"] = "XS";
  Breakpoint["XXS"] = "XXS";
  return Breakpoint;
}({});
var XS = 360;
var S = 480;
var M = 768;
var L = 1024;
var XL = 1440;
export var minBreakpoints = {
  XXS: 0,
  XS,
  S,
  M,
  L,
  XL
};
export var maxBreakpoints = {
  XXS: XS - 1,
  XS: S - 1,
  S: M - 1,
  M: L - 1,
  L: XL - 1
};